import { Builder } from '@builder.io/react';

import HeaderCallCampaignButton from './header-call-campaign';

Builder.registerComponent(HeaderCallCampaignButton, {
  name: 'HeaderCallCampaignButton',
  noWrap: true,
});
